import insights from "./insights";
import home from "./home";
export default { insights, home };
